import { Box, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconLogout, IconRefresh, IconServerOff } from "@tabler/icons-react";
import { repair } from "@/utils/auth/repair";

export default function ErrorServer() {
	return (
		<Stack h="100vh" justify="center" align="center" p="md">
			<ThemeIcon variant="transparent" size={64} color="red">
				<IconServerOff style={{ width: "100%", height: "100%" }} />
			</ThemeIcon>

			<Title ta="center" order={1}>
				No se puede conectar con el servidor
			</Title>

			<Text ta="center" size="lg">
				Verifica tu conexión a internet e inténtalo de nuevo.
			</Text>

			<Box>
				<Stack align="center">
					<Button
						size="lg"
						leftSection={<IconRefresh />}
						onClick={() => window.location.reload()}
					>
						Reintentar
					</Button>

					<Button
						variant="subtle"
						color="red"
						leftSection={<IconLogout />}
						onClick={() => repair()}
					>
						Cerrar sesión
					</Button>
				</Stack>
			</Box>
		</Stack>
	);
}
